

    var echarts = require('../echarts');

    require('./treemap/TreemapSeries');
    require('./treemap/TreemapView');
    require('./treemap/treemapAction');

    echarts.registerVisual(require('./treemap/treemapVisual'));

    echarts.registerLayout(require('./treemap/treemapLayout'));



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/treemap.js
// module id = 887
// module chunks = 158